var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9683 28.6367C9.34758 28.6367 3.98047 23.2696 3.98047 16.6489L3.98047 16.3517L27.956 16.3517L27.956 16.6489C27.956 23.2696 22.5889 28.6367 15.9683 28.6367Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9683 16.3516C9.34758 16.3516 3.98047 10.9845 3.98047 4.36378L3.98047 4.06656L27.956 4.06656L27.956 4.36378C27.956 10.9845 22.5889 16.3516 15.9683 16.3516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape6);
export default __webpack_public_path__ + "static/media/shape6.d02f5a0e5212ebfef4320640958b884f.svg";
export { ForwardRef as ReactComponent };